export default (val)=>val.replace(/\s+/ig,'-')



// WEBPACK FOOTER //
// ./src/util/space.js